import { render, staticRenderFns } from "./Poznamky.vue?vue&type=template&id=62efcf9d&"
import script from "./Poznamky.vue?vue&type=script&lang=ts&"
export * from "./Poznamky.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports